module.exports = __webpack_public_path__ + "img/collectiongallery_naturalbeige@2x.38f6c86.jpg";